const $ = jQuery.noConflict();

class Slider {
	constructor( selector, args = {} ) {
		this.selector = selector;
		this.args = args;
	}

	getDefaultSlickSettings() {
		return {
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			speed: 600,
		}
	}

	/**
	 * Override our default slick settings with args provided to the class.
	 */
	getSlickSettings() {
		return Object.assign( {}, this.getDefaultSlickSettings(), this.args );
	}

	init() {
		let settings = this.getSlickSettings();

		$( this.selector ).slick( settings );
	}
}

const SimpleSlider = new Slider('.gallery-slider__slider');
const TestimonialSlider = new Slider(
	'.testimonial-slider',
	{
		dots: true, 
	}
);
const FluidSlider = new Slider(
	'.gallery-slider__slider-fluid', 
	{
		 
		
		centerMode: true,
		centerPadding: '200px', 
		slidesToShow: 1,

		responsive: [
			{
				breakpoint: 1400,
				settings: {  
					centerMode: false,
					variableWidth: false,
				},
			},
			{
				breakpoint: 1290,
				settings: { 
					centerMode: false,
					variableWidth: false,
				},
			}, 
			{
				breakpoint: 1025,
				settings: {
					centerPadding: '80px',
					centerMode: true,
					variableWidth: false,
				},
			},
			{
				breakpoint:770,
				settings: {
					centerPadding: '80px',
					centerMode: true,
					variableWidth: false,
				},
			},
			{
				breakpoint: 480,
				settings: {
					centerPadding: '40px',
					centerMode: true,
					variableWidth: false,
				},
			},
		],
	}
);
const EventsSlider = new Slider(
	'.block-featured-events__slider',
	{
		slidesToShow: 2,
		dots: false,
		infinite: true,  
		variableWidth: false, 
		responsive:[
			{
			  breakpoint: 1025,
			  settings: {
				slidesToShow: 1,  
			  }
			},		
			{
			  breakpoint: 770,
			  settings: {
				slidesToShow: 1,  
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
				centerMode:true,
				slidesToShow: 1,
				centerPadding: '10px',
			  }
			},		
		],
		 
	}
);
export { SimpleSlider, TestimonialSlider, FluidSlider, EventsSlider };
